export default __webpack_public_path__ + "static/media/giftVoucher.6b013d72.png";